<script>
  // imgBB: album B&W
  let pics = [
    "https://i.ibb.co/cy1pJ62/BW-IMG-2769.jpg",
    "https://i.ibb.co/zmz5ddz/DSC-0016.jpg",
    "https://i.ibb.co/Lx3tLGr/DSC-0068.jpg",
    "https://i.ibb.co/S6qBp3W/DSC-0127.jpg",
    "https://i.ibb.co/BLMSsb6/DSC-0141.jpg",
    // "https://i.ibb.co/GPPfW20/DSC-0254.jpg",
    "https://i.ibb.co/r5BXcgB/DSC-0292.jpg",
    "https://i.ibb.co/1nsRh6J/DSC-0293.jpg",
    "https://i.ibb.co/Rh6SmPm/DSC-0667.jpg",
    "https://i.ibb.co/TMHdJHy/DSC-0720.jpg",
    "https://i.ibb.co/1vwCGss/IMG-1741.jpg",
    "https://i.ibb.co/YQHm3Y9/IMG-2609.jpg",
    "https://i.ibb.co/v1Vy5TZ/IMG-3613.jpg",
    "https://i.ibb.co/9sFfhj6/IMG-3708.jpg",
    "https://i.ibb.co/yXwsLZb/IMG-4222.jpg",
    "https://i.ibb.co/RyVKh4s/IMG-5741.jpg",
    "https://i.ibb.co/xJCPBFB/IMG-5820.jpg",
    "https://i.ibb.co/PxX4JWS/IMG-5826.jpg",
    "https://i.ibb.co/vJzdtrY/IMG-6191.jpg",
    "https://i.ibb.co/1GqkztD/IMG-6363.jpg",
    "https://i.ibb.co/3dHzPWC/IMG-6610.jpg",
    "https://i.ibb.co/x3DFR1G/P1150677.jpg",
    "https://i.ibb.co/DtQvxwG/P1150787.jpg",
    "https://i.ibb.co/Rg3zTLJ/P1150811.jpg",
    "https://i.ibb.co/16bWBWb/P1150818.jpg",
    "https://i.ibb.co/WPNxRFf/P1150854.jpg",
    "https://i.ibb.co/5vSSrwy/P1190044.jpg",
    "https://i.ibb.co/4YZ6n8c/P1190047.jpg",
    "https://i.ibb.co/JpPrCvq/P1190074.jpg",
    "https://i.ibb.co/NxdpMcB/San-Francisco-2.jpg",
    "https://i.ibb.co/kghwhFx/San-Francisco-3.jpg",
    "https://i.ibb.co/fv5N3dF/San-Francisco.jpg",
  ]

  const randomPicture = () => {
    var max = 30
    var min = 0
    var index = Math.floor(Math.random() * (max - min + 1)) + min
    // console.log("picture index is : " + index)
    return pics[index]
  }
</script>

<main>
  <h3>Welcome to Cloudidi</h3>
  <p>
    Thanks much for dropping by! Let me share with you some of my
    black-and-white pictures here - randomly picked from my image hosting
    service.
  </p>

  <img class="home-img" src={randomPicture()} alt="Random picture" />
</main>

<style>
  .home-img {
    width: 100%;
  }
</style>
